<template>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <div class="datatables">
      <div class="block block-mode-hidden">
        <div v-if="tableLoader && showLoader" class="overlay"></div>
        <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#5c80d1" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-primary">
          <h3 class="block-title text-white">
            <i class="fa fa-cannabis"></i> Strains ({{ Object.keys(strains).length }})
            <span class="hash-loader" v-if="showLoader && !tableLoader">
              <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
            </span>
          </h3>
          <div class="block-options">
            <button type="button" class="btn-block-option text-white" @click.prevent="showModifyStrainModal(false, null)">
              <i v-bind:disabled="showLoader" class="si si-plus"></i> Add New
            </button>
            <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
          </div>
        </div>
        <div class="block-content block-content-full">
          <table id="strains-table" class="table table-bordered table-striped table-vcenter js-dataTable-full table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Strain</th>
                <th class="no-sorting">Functions</th>
              </tr>
            </thead>
            <tbody>{{ getStrainEntries }}
              <tr v-for="(strain, index) in strains" :key="index">
                <td class="text-center font-size-sm">{{ strain.Id }}</td>
                <td class="font-w600 font-size-sm text-break-large">{{ strain.Name }}</td>
                <td>
                  <a href="#" title="Edit" @click.prevent="showModifyStrainModal(true, strain)">
                  <i class="fa fa-fw fa-pencil-alt"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ModifyStrain ref="modifyStrain" @showSuccessMsg="showSuccessModal" @loadStrains="fetch"></ModifyStrain>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import ModifyStrain from '@/components/modals/ModifyStrain';
Vue.use(VueSpinners);

export default {
  name: 'Strain',
  data() {
    return {
      isTableEnabled: false,
      strains: [],
      showLoader: false,
      tableLoader: false,
    };
  },
  components: {
    HashLoader,
    ModifyStrain
  },
  created() {
    this.fetch(false);
  },
  computed: {
    getStrainEntries() {
      if (this.$store.state.library.strains.length) {
        return this.enableDataTable(this.$store.state.library.strains);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllStrains']),
    ...mapGetters('library', ['getStrains']),
    async fetch(force) {
      if (force || this.getStrains().length === 0) {
        this.showLoader = true;
        await this.getAllStrains();
      }
      if (this.getStrains().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#strains-table').DataTable();
        table.destroy();
      }
      vm.strains = data;
      vm.prepareDataTable('#strains-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showModifyStrainModal(isEdit, strain) {
      let vm = this;
      jQuery('#modify_strain').modal('show');
      setTimeout(() => {
        if (isEdit) {
          vm.$refs.modifyStrain.loadStrain(strain);
        } else {
          vm.$refs.modifyStrain.updateSlider(50);
          vm.$refs.modifyStrain.setRangeSliderColor({from_percent: 50});
        }
      }, 750);
    },
    showSuccessModal(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    }
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>
<style>
.errorMsg {
  color: red;
  font-size: 0.7rem;
  margin-bottom: 0 !important;
  line-height: 16px;
  padding-top: 5px;
}
.form-group.required .control-label:after {
  content:"*";
  color:red;
}
.custom-class {
  margin: 0 !important;
}
.hash-loader {
  width: auto !important;
  padding-left: 23px;
  position: relative;
}
.hash-icon {
  display: inline-block;
  position: absolute !important;
  left: 2px;
  top: 1px;
}
.overlay {
  background: rgba(0,0,0,0.2);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}
.datatables .block {
  position: relative;
}
.table-hash-icon {
  z-index: 9999;
  top: 47%;
  left: 47%;
}
.alert-message {
  border-radius: .3rem;
  box-shadow: none;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.alert-error-message {
  padding: 15px;
}
.alert-message-top {
  margin-top: 20px;
}
.modal-loader {
  padding-left: 6px;
  padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// source/components/boxes/Strain.vue